/* Moved from the inline <script> in snippets/facet-filters.liquid (PageSpeed batch 6). Guarded so it runs once even if the snippet renders twice. */
(function () {
  if (window.__kgFacetFiltersDrawerLoaded) return;
  window.__kgFacetFiltersDrawerLoaded = true;



  function goBackFromNestedDrawer(button) {


    return new Promise((resolve) => {


      const panel = button.closest('.filter__drawer-panel');


      if (!panel) {

        return resolve();

      }


      panel.classList.add('closing');



      setTimeout(() => {


        panel.classList.remove(
          'open',
          'closing'
        );



        const mainDrawer =
          document.getElementById(
            'FilterDrawer'
          );



        if (
          mainDrawer &&
          !mainDrawer.querySelector(
            '.filter__drawer-panel.open'
          )
        ) {

          mainDrawer.classList.remove(
            'nested-open',
            'nested-filter-open',
            'nested-menu-open'
          );

        }




        const parentDetails =
          panel.closest(
            'details'
          );



        if (
          parentDetails
        ) {

          parentDetails.removeAttribute(
            'open'
          );

          void parentDetails.offsetWidth;

        }




        if (
          !panel.id.startsWith(
            'menu-drawer'
          )
        ) {

          document
            .querySelectorAll(
              '.filter__menu'
            )
            .forEach(
              (menu) => {

                menu.style.display = '';

              }
            );

        }




        if (
          mainDrawer &&
          !mainDrawer.classList.contains(
            'open'
          )
        ) {

          setTimeout(
            () => {

              mainDrawer
                .classList
                .add(
                  'open'
                );

            },
            10
          );

        }



        resolve();


      }, 300);


    });


  }




  function openFilterDrawer() {


    const drawer =
      document.getElementById(
        'FilterDrawer'
      );


    const overlay =
      document.getElementById(
        'custom-filter-overlay'
      );


    const facetFilters =
      drawer?.querySelector(
        'facet-filters'
      );



    drawer?.classList.add(
      'open'
    );


    document.body.classList.add(
      'drawer-open'
    );


    overlay?.classList.add(
      'active'
    );



    if (
      facetFilters
    ) {

      facetFilters.classList.remove(
        'hidden'
      );


      facetFilters.hidden =
        false;


      facetFilters.setAttribute(
        'aria-hidden',
        'false'
      );

    }


  }




  function closeFilterDrawer() {


    const drawer =
      document.getElementById(
        'FilterDrawer'
      );


    const overlay =
      document.getElementById(
        'custom-filter-overlay'
      );


    const facetFilters =
      drawer?.querySelector(
        'facet-filters'
      );



    if (
      !drawer
    ) {

      return;

    }



    drawer.classList.add(
      'closing'
    );


    document.body.classList.remove(
      'drawer-open'
    );



    setTimeout(
      () => {


        drawer.classList.remove(
          'open',
          'closing'
        );


        overlay?.classList.remove(
          'active'
        );



        if (
          facetFilters
        ) {


          facetFilters.classList.add(
            'hidden'
          );


          facetFilters.hidden =
            true;


          facetFilters.setAttribute(
            'aria-hidden',
            'true'
          );


        }


      },
      300
    );


  }




  function bindDrawerCloseButton() {


    document
      .querySelectorAll(
        '.filter__drawer-close'
      )
      .forEach(
        (button) => {


          button.addEventListener(
            'click',
            function (e) {


              e.preventDefault();




              const mainDrawer =
                document.getElementById(
                  'FilterDrawer'
                );




              if (
                mainDrawer?.classList.contains(
                  'open'
                )
              ) {


                mainDrawer
                  .classList
                  .remove(
                    'open'
                  );


                document
                  .body
                  .classList
                  .remove(
                    'drawer-open'
                  );


              }




              document
                .querySelectorAll(
                  '.filter.disclosure[open]'
                )
                .forEach(
                  (detail) => {


                    detail.removeAttribute(
                      'open'
                    );


                  }
                );




              document
                .querySelectorAll(
                  '.filter__drawer-panel.open'
                )
                .forEach(
                  (panel) => {


                    panel.classList.remove(
                      'open'
                    );


                  }
                );


            }
          );


        }
      );


  }





  document.addEventListener(
    'DOMContentLoaded',
    function () {



      function resetNestedDrawerScroll(drawer) {


        if (
          !drawer
        ) {

          return;

        }



        const drawerContent =
          drawer.querySelector(
            '.filter__drawer-content'
          );



        const filterDrawerContent =
          drawer
            .closest(
              '#FilterDrawer'
            )
            ?.querySelector(
              ':scope > .drawer-content'
            );



        const facetFilters =
          drawer.closest(
            'facet-filters'
          );



        if (
          filterDrawerContent
        ) {

          filterDrawerContent.scrollTop =
            0;

        }



        if (
          facetFilters
        ) {

          facetFilters.scrollTop =
            0;

        }



        drawer.scrollTop =
          0;



        if (
          drawerContent
        ) {

          drawerContent.scrollTop =
            0;

        }


      }




      function closeActiveDrawer() {


        const activeDrawer =
          document.querySelector(
            '.filter__drawer-panel.open'
          );



        if (
          activeDrawer
        ) {


          activeDrawer
            .classList
            .remove(
              'open'
            );


          document
            .body
            .classList
            .remove(
              'drawer-open'
            );


        }


      }




      if (
        !window.__kgProductsToolbarNestedDrawer
      ) {


        document.addEventListener(
          'click',
          function (e) {



            const button =
              e.target.closest(
                '.open-nested-drawer'
              );



            if (
              !button
            ) {

              return;

            }



            e.preventDefault();




            const parentDetails =
              button.closest(
                'details'
              );



            const drawerId =
              button.getAttribute(
                'data-drawer-id'
              );



            const drawer =
              document.getElementById(
                drawerId
              );




            document
              .querySelectorAll(
                '.filter.disclosure[open]'
              )
              .forEach(
                (detail) => {


                  if (
                    detail !==
                    parentDetails
                  ) {


                    detail.removeAttribute(
                      'open'
                    );



                    const openPanel =
                      detail.querySelector(
                        '.filter__drawer-panel'
                      );



                    if (
                      openPanel
                    ) {


                      openPanel
                        .classList
                        .remove(
                          'open'
                        );


                    }


                  }


                }
              );




            if (
              parentDetails &&
              !parentDetails.hasAttribute(
                'open'
              )
            ) {


              parentDetails.setAttribute(
                'open',
                ''
              );


            }




            if (
              drawer
            ) {


              drawer.classList.remove(
                'open'
              );


              resetNestedDrawerScroll(
                drawer
              );



              requestAnimationFrame(
                () => {


                  drawer.classList.add(
                    'open'
                  );


                  resetNestedDrawerScroll(
                    drawer
                  );


                  document
                    .body
                    .classList
                    .add(
                      'drawer-open'
                    );


                }
              );


            }


          }
        );


      }




      bindDrawerCloseButton();




      document.addEventListener(
        'keydown',
        function (e) {


          if (
            e.key ===
            'Escape'
          ) {

            closeActiveDrawer();

          }


        }
      );


    }
  );





  document
    .querySelectorAll(
      '.js-show-more'
    )
    .forEach(
      (button) => {


        button.addEventListener(
          'click',
          function (e) {


            e.preventDefault();

            e.stopPropagation();



            const drawerContent =
              this.closest(
                '.filter__drawer-content'
              );



            if (
              !drawerContent
            ) {

              return;

            }



            const list =
              drawerContent
                .querySelector(
                  'ul[role="list"]'
                );



            if (
              !list
            ) {

              return;

            }



            list
              .querySelectorAll(
                '.js-hidden'
              )
              .forEach(
                (el) => {


                  el.classList.remove(
                    'js-hidden'
                  );


                }
              );



            this.remove();




            const drawerPanel =
              this.closest(
                '.filter__drawer-panel'
              );



            if (
              drawerPanel &&
              !drawerPanel.classList.contains(
                'open'
              )
            ) {


              drawerPanel
                .classList
                .add(
                  'open'
                );


            }


          }
        );


      }
    );


  window.goBackFromNestedDrawer = goBackFromNestedDrawer;
  window.openFilterDrawer = openFilterDrawer;
  window.closeFilterDrawer = closeFilterDrawer;
  window.bindDrawerCloseButton = bindDrawerCloseButton;
})();
